import { asyncRouterMap, constantRouterMap } from '@/router/index';

// function changeRoute(level:number, index: number):void {
 
// }

function hasPermission(menus:any, route:any) {
    return true;
}

function getMenu(name: string, menus: any) {
    for (let i = 0; i < menus.length; i++) {
      let menu = menus[i];
      if (name===menu.name) {
        return menu;
      }
    }
    return null;
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: []
    },
    mutations: {
        SET_ROUTERS: (state:any, routers: any) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
        }
    },
    actions: {
        GenerateRoutes({commit}: any, data: any) {
            return new Promise(resolve => {
                const { menus } = data;
                const accessedRouters = asyncRouterMap.filter(v => {
                    //admin帐号直接返回所有菜单
                    // if(username==='admin') return true;
                    if (hasPermission(menus, v)) {
                      if (v.children && v.children.length > 0) {
                        v.children = v.children.filter((child:any) => {
                          if (hasPermission(menus, child)) {
                            return child
                          }
                          return false;
                        });
                        return v
                      } else {
                        return v
                      }
                    }
                    return false;
                  });
                  commit('SET_ROUTERS', accessedRouters);
                  resolve();
            })
        }
    }
}
//const menus:any[] = [{index: 1, name: "ok", api: ["www.test.com"]}];
export default permission;